// Aprovação do câmbio Inter (Rafael 23/10): no Efetivo, só quem tem a permissão "Aprovar câmbio Inter" (Tati e
// Vanessa, dada na tela de Permissões de Acesso) aprova o câmbio do fornecedor pago no exterior. As outras
// responsáveis do evento veem a tag de quem falta aprovar e, depois, quem aprovou. A API confere a mesma regra.

// "Tati ou Vanessa" (os primeiros nomes que a API manda em cambio_banco.aprovadores).
export function rotuloAprovadores(nomes = []) {
    const lista = (nomes || []).map((n) => String(n || '').trim()).filter(Boolean);
    if (lista.length === 0) return 'pessoa responsável';
    if (lista.length === 1) return lista[0];
    return lista.slice(0, -1).join(', ') + ' ou ' + lista[lista.length - 1];
}

const dataHora = (iso) => {
    const d = iso ? new Date(iso) : null;
    if (!d || Number.isNaN(d.getTime())) return '';
    return d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
};

// Tag do câmbio no card do fornecedor; null quando o Financeiro ainda não lançou a cotação do banco.
export function tagCambio(cambioBanco, liberado = false) {
    if (!cambioBanco) return null;
    if (cambioBanco.aprovado_em || cambioBanco.aprovado_por || liberado) {
        const quando = dataHora(cambioBanco.aprovado_em);
        return {
            cls: 'is-ok',
            label: '✅ Câmbio aprovado' + (cambioBanco.aprovado_por ? ' por ' + cambioBanco.aprovado_por : '') + (quando ? ' em ' + quando : ''),
        };
    }
    return { cls: 'is-warn', label: '⏳ Aguardando aprovação de câmbio (' + rotuloAprovadores(cambioBanco.aprovadores) + ')' };
}

// Por que o botão "Aprovar câmbio" fica desabilitado para quem não tem a permissão; null = pode aprovar.
export function motivoSemPermissaoCambio(podeAprovar, nomes = []) {
    if (podeAprovar) return null;
    return 'Aguardando aprovação de câmbio pela ' + rotuloAprovadores(nomes) + '.';
}
